/**
 * EmailVerifiedGate — redirects unverified email/password users to /verify-email.
 * Uses BACKEND user.emailVerified flag (Firebase-native verification no longer used).
 * Google/Apple users come through with emailVerified=true from provider.
 */
import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';

export function EmailVerifiedGate({ children }: { children: ReactNode }) {
  const loc = useLocation();
  const { user } = useAuth();

  if (loc.pathname === '/verify-email' || loc.pathname === '/login') return <>{children}</>;
  if (!user) return <>{children}</>;

  const raw = user as unknown as { emailVerified?: boolean; email_verified?: boolean };
  const verified = raw.emailVerified ?? raw.email_verified ?? false;

  if (!verified) {
    return <Navigate to="/verify-email" replace state={{ from: loc }} />;
  }
  return <>{children}</>;
}
